import AuthService from '../../../services/auth-service';
import types from './mutation-types';
import Vue from 'vue';
import authHelper from '@/helpers/auth';
import { isNil } from 'lodash';
import { hasLaravelErrors, LaravelErrors } from '@/helpers/laravel-errors';
import i18n from '@/language';

class Authentication {

	constructor(commit) {
		this.commit = commit;
	}

	login(credentials) {
		this.commit(types.LOGIN);
		authHelper.removeAccessToken();

		AuthService.authenticate(credentials)
			.then(this.getUserAuthData.bind(this), this.handleChainError.bind(this))
			.then(this.checkLogin.bind(this), this.handleChainError.bind(this))
			.catch(this.handleError.bind(this));
	}

	getUserAuthData(response) {
		const accessToken  = response.data['access_token'];
		const refreshToken = response.data['refresh_token'];

		authHelper.setAccessToken(accessToken);
		authHelper.setRefreshToken(refreshToken);

		return this.fetchMe().then(response => {
			return { response, accessToken, refreshToken };
		});
	}

	fetchMe() {
		return AuthService.getMe().then(response => {
				this.commit(types.SET_ME, response.data);
				return response;
			})
			.catch(error => this.handleError(error));
	}

	handleChainError(error) {
		return Promise.reject(error);
	}

	handleError(error) {
		let commitError;

		if (hasLaravelErrors(error)) {
			commitError = new LaravelErrors(error).getOne();
		} else {
			commitError = new Error(i18n.t('auth.errorPleaseRetry'));
		}

		authHelper.removeAccessToken();
		this.commit(types.LOGIN_FAILED, commitError);
	}

	checkLogin({ response, accessToken }) {
		if (!this.hasAdminRole(response.data.roles)) {
			throw new Error(i18n.t('auth.noAdminRoleError'));
		} else {
			this.commit(types.LOGIN_SUCCESS, accessToken);
		}
	}

	hasAdminRole(roles) {
		return (roles.find(role => (role.name == 'admin')) !== undefined);
	}

	logout(commit) {
		authHelper.removeAccessToken();
		this.commit(types.LOGOUT);
	}

}

const actions = {
	login({ commit }, credentials) {
		new Authentication(commit).login(credentials);
	},
	logout({ commit }) {
		new Authentication(commit).logout();
	},
	fetchMe({ commit }) {
		new Authentication(commit).fetchMe();
	}
};

export default actions;


// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js